// import config from 'config';
import axios from "axios";
import { getApiRequest, getApiRequestAsync, postApiRequest, postFileApiRequest, putApiRequest, deleteApiRequest } from '../_helpers';

const path = '/timereport/approval/'

export const timereportapprovalService = {
  getAll,
  get,
  post,
  put,
  remove,
};

function getAll(employee_id, start, end) {
  const params = {
    employee_id: employee_id,
    start: start,
    end: end,
  }
  return getApiRequestAsync(path, params)
}

function get(id) {
  return getApiRequest(path + id + '/')
}

function post(data) {
  return postApiRequest(path, data, {})
}

function put(id, data) {
  return putApiRequest(path + id + '/', data, {})
}

function remove(id) {
  return deleteApiRequest(path + id + '/')
}
